import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'formatProductSize'
})
export class FormatProductSizePipe implements PipeTransform {
  transform(height: number, width: number, unit = 'cm') {
    return StringHelper.join(
      [
        height == null ? '' : `${height}${unit} H`,
        width == null ? '' : `${width}${unit} B`
      ],
      ' x '
    );
  }
}
